import React from 'react';
import MasterFileUploader from '../Components/MasterFileUploader.js';
import { WebServiceContextConsumer, withApi } from '../Providers/WebServiceProvider.js';

const Upload = () => {
  return (
		<div className="columns">
			<div className="column is-6 is-offset-3">
		  	<div className="section">
			  	<div className="page-section">
						<WebServiceContextConsumer>
						{ 
							context => <MasterFileUploader {...context} />
						}
				  	</WebServiceContextConsumer>
			  	</div>
		  	</div>
			</div>
  	</div>
  );
}

export default withApi(Upload);


// WEBPACK FOOTER //
// ./src/Pages/Upload.js